import React from "react";
import {  Alert } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import DeductionForm from "./utilities/DeductionForm";
import DeductionTable from "./utilities/DeductionTable";
import DeletionConfirmationModal from "./utilities/DeletionConfirmationModal";
import DisableConfirmationModal from "./utilities/DisableConfirmationModal";
import useDeductionData from "./utilities/useDeductionData";

const AssignDeductions = (props) => {
  const {
    employee,
    isLoading,
    isSaving,
    isDeleting,
    isDisabling,
    successMessage,
    backendError,
    totalDeductions,
    netSalary,
    assignedDeductions,
    allDeductions,
    deductionsByCategory,
    selectedDeduction,
    setSelectedDeduction,
    customAmount,
    setCustomAmount,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    currentDeduction,
    handleSubmit,
    handleRemoveDeduction,
    handleDisableDeduction,
    openDeleteModal,
    closeDeleteModal,
    showDeleteModal,
    deductionToDelete,
    openDisableModal,
    closeDisableModal,
    showDisableModal,
    deductionToDisable,
    clearForm,
    tableData,
    deductionColumns,
    isDeductionAlreadyAssigned,
  } = useDeductionData();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading data...</p>
        </div>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="text-center p-5">
        <div className="alert alert-warning">
          <i className="fa fa-exclamation-triangle fa-2x mb-3"></i>
          <h5>{props.t("employee_not_found")}</h5>
          <p>{props.t("cannot_find_employee")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="patients-list-content">
      <div className="patients-list px-2 pb-5">
        <div className="container-fluid">

          {/* Header */}
          <div className="heading-parent-sec">
            <div className="heading-parent-sec d-flex align-items-center pt-4">
              {/* Bouton retour */}
              <button
                onClick={() => navigate(-1)}
                className="btn btn-link p-0 me-3"
                style={{ textDecoration: "none", color: "#0d6efd" }}
              >
               <h6> {props.t("staff_management")}</h6>
              </button>
              <h6><span style={{ fontWeight: "bold" }}> /&nbsp; </span> {props.t("assign_deductions")} - {employee.fullName}</h6>
            </div>
          </div>

          {/* Messages d'alerte */}
          <div className="mt-3">
            {successMessage && (
              <Alert color="success" className="alert-dismissible">
                <i className="fa fa-check-circle me-2"></i>
                {successMessage}
              </Alert>
            )}
            {/* {backendError && (
              <Alert color="danger" className="alert-dismissible">
                <i className="fa fa-exclamation-circle me-2"></i>
                <strong> {props.t("Error")} :</strong> {backendError}
              </Alert>
            )} */}
            {allDeductions.length === 0 && assignedDeductions.length > 0 && (
              <Alert color="warning" className="alert-dismissible">
                <i className="fa fa-info-circle me-2"></i>
                 {props.t("All_deductions_are_assigned")}
              </Alert>
            )}
            {allDeductions.length === 0 && assignedDeductions.length === 0 && (
              <Alert color="info" className="alert-dismissible">
                <i className="fa fa-info-circle me-2"></i>
                {props.t("no_availble_deductions")}
              </Alert>
            )}
          </div>

          {/* Employee info card remove*/}


          {/* Deduction Form */}
          {allDeductions.length > 0 && (
            <DeductionForm
              allDeductions={allDeductions}
              deductionsByCategory={deductionsByCategory}
              selectedDeduction={selectedDeduction}
              setSelectedDeduction={setSelectedDeduction}
              customAmount={customAmount}
              setCustomAmount={setCustomAmount}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              currentDeduction={currentDeduction}
              handleSave={handleSubmit}
              isSaving={isSaving}
              backendError={backendError}
              isDeductionAlreadyAssigned={isDeductionAlreadyAssigned}
            />
          )}

          {/* Deduction Table */}
          <DeductionTable
            tableData={tableData}
            deductionColumns={deductionColumns}
            assignedDeductions={assignedDeductions}
            openDeleteModal={openDeleteModal}
            openDisableModal={openDisableModal}
            handleDisableDeduction={handleDisableDeduction}
            isDeleting={isDeleting}
            isDisabling={isDisabling}
          />

          {/* Modal de confirmation de suppression */}
          <DeletionConfirmationModal
            isOpen={showDeleteModal}
            toggle={closeDeleteModal}
            onConfirm={handleRemoveDeduction}
            isDeleting={isDeleting}
            deductionToDelete={deductionToDelete}
          />

          {/* Modal de confirmation de disable */}
          <DisableConfirmationModal
            isOpen={showDisableModal}
            toggle={closeDisableModal}
            onConfirm={handleDisableDeduction}
            isDisabling={isDisabling}
            deductionToDisable={deductionToDisable}
          />

        </div>
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(AssignDeductions));
